module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3e83d9d800459175308f0b45b117af16.png";